import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FileUploadService } from '../../core-services/FileUpload.service';
import { TranslationService } from '../../translations';

@Component({
    selector: 'file-upload',
    template: `
        <div class="fileUpload">
            <div
                ng2FileDrop
                [ngClass]="setFileUploadClasses()"
                (fileOver)="fileOverBase($event)"
                [uploader]="fileUploadService.fileUploader"
                class="drop-zone"
            >
                <ng-content select=".infoDetails"></ng-content>
                @if (!isUploadDisabled) {
                    <div class="placeholder">
                        <span class="uploadIcon"
                            ><i class="ico-moon ico-moon-file-upload"></i
                        ></span>
                        @if (!getFileName()) {
                            <div class="placeholderText">
                                {{ TR.key(placeHolderTextKey) }}
                            </div>
                        }
                        <div class="fileName">{{ getFileName() }}</div>
                        <div class="smallText">{{ validationMessage }}</div>
                        <div class="buttons">
                            @if (!getFileName() && !isUploadDisabled) {
                                <div style="margin: 0 auto;">
                                    <span style="padding-right:25px;">{{
                                        TR.key('Or')
                                    }}</span>
                                    <label
                                        for="file-upload"
                                        class="btn btn--lsg btn--lsg--primary custom-file-upload"
                                    >
                                        {{
                                            TR.key(
                                                'fileUpload.button-selectFile'
                                            )
                                        }}
                                    </label>
                                </div>
                            }
                            <input
                                style="display:none;"
                                id="file-upload"
                                type="file"
                                ng2FileSelect
                                [uploader]="fileUploadService.fileUploader"
                                (change)="onFileChange($event)"
                                [accept]="acceptFileTypes"
                            />
                            @if (getFileName()) {
                                <button
                                    class="button button-secondary button-sm"
                                    (click)="fileUploadService.clearUpload()"
                                >
                                    {{ TR.key('text.common-terms.cancel') }}
                                </button>
                            }
                            @if (getFileName()) {
                                <button
                                    class="button button-primary button-sm"
                                    (click)="beginUpload()"
                                    [disabled]="disableUploadButton"
                                >
                                    {{ this.getUploadButtonLabel() }}
                                </button>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    `,
    standalone: false
})
export class FileUploadComponent {
    @Input()
    placeHolderTextKey = 'fileUpload.placeholder-default';

    @Input()
    hasErrorOccured = false;

    @Input()
    isUploadDisabled = false;

    @Input()
    cssClass = '';

    @Input()
    uploadButtonLabel = '';

    @Input()
    acceptFileTypes = '';

    @Input()
    disableUploadButton = false;

    @Input()
    validationMessage: string;

    @Output()
    onFileAddComplete: EventEmitter<boolean> = new EventEmitter();
    @Output()
    onBeginUpload: EventEmitter<boolean> = new EventEmitter();

    public uploadedFileAsText: string;

    hasBaseDropZoneOver = false;

    constructor(
        public fileUploadService: FileUploadService,
        public TR: TranslationService
    ) {
        this.fileUploadService.initialize();
        this.fileUploadService.fileAddingComplete$.subscribe(() => {
            this.onFileAddComplete.emit();
        });
    }

    fileOverBase(e: any): void {
        if (!this.isUploadDisabled) {
            this.hasBaseDropZoneOver = e;
        }
    }

    beginUpload() {
        if (!this.isUploadDisabled) {
            this.onBeginUpload.emit(true);
        }
    }

    getFileName() {
        return this.fileUploadService.uploadedFileName;
    }

    setFileUploadClasses() {
        return {
            'file-over': this.hasBaseDropZoneOver,
            'file-ready': this.getFileName(),
            'file-error': this.hasErrorOccured,
            [this.cssClass]: 'true'
        };
    }

    getUploadButtonLabel() {
        if (this.uploadButtonLabel) {
            return this.uploadButtonLabel;
        } else {
            return this.TR.key('fileUpload.button-upload');
        }
    }

    // Handles the bug where  input[type=file] element holds the old file
    // even in the case the file is cleared from File Upload service
    onFileChange(event: any): void {
        event.srcElement.value = '';
    }
}
